// extracted by mini-css-extract-plugin
export default {"form":"Form_form__mhxSI","h3":"Form_h3__1QZGt","label":"Form_label__wFkUd","input":"Form_input__yL++I","btn":"Form_btn__JLkH0"};